import { render, staticRenderFns } from "./DicType.vue?vue&type=template&id=df84ac0a"
import script from "./DicType.vue?vue&type=script&lang=js"
export * from "./DicType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports